import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import { PollGlyphIcon24 } from 'assets/icons'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'
import FormBlock from './FormBlock'
import ResultsBlock from './ResultsBlock'

const ObjectSurveyBlock = () => {
   const { initiative } = useContext(InitiativeHierarchyContext)

   const hasSurvey = initiative.appsSurveyEnabled && initiative.appsSurveyFormElements.length > 0
   if (!hasSurvey) {
      return null
   }

   const userCompletedSurvey = initiative.currentUserRelationship?.elements?.find(
      element => element.__typename === 'RelationshipElementSurveyParticipant')

   return (
      <View
         position="relative"
         border="1px solid #eee"
         padding="30px 20px 30px 80px"
         marginBottom="30px"
         borderRadius="6px">
         <View
            display="flex"
            alignItems="center"
            justifyContent="center"
            position="absolute"
            top="30px"
            left="20px"
            width="40px"
            height="40px"
            borderRadius="50%"
            backgroundColor="rgba(125, 60, 231, 0.1)">
            <PollGlyphIcon24 width="18px" height="18px" color="#7d3ce7" />
         </View>
         <Text size="3" color="#333">
            {initiative.appsSurveyFormElements[0].label}
         </Text>
         {userCompletedSurvey && <ResultsBlock />}
         {!userCompletedSurvey && <FormBlock />}
      </View>
   )
}

export default ObjectSurveyBlock
